import { instance } from "libs/api";

import { ApiRoutesFinancialReport } from "../../constants";
import {
  AdPerformanceResponse,
  FinancialPeriodParams
} from "../financialReport.types";

export const requestAdPerformance = async (
  params: FinancialPeriodParams
): Promise<AdPerformanceResponse> => {
  return await instance.get(ApiRoutesFinancialReport.Advertising, { params });
};
